<template>
  <div v-if="context" class="tw-px-6 tw-py-3">
    <div class="tw-flex tw-justify-between tw-items-center">
      <div
        class="
          tw-text-base
          tw-leading-[22px]
          tw-text-sf-gray-darker
          tw-font-medium
          tw-break-normal
        "
        data-testid="sf-sidepane-context-name"
      >
        {{ context.itemName }}
      </div>
      <WorkflowReviewSidepaneTagsFilter />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import WorkflowReviewSidepaneTagsFilter from './workflow-review-sidepane-tags-filter.vue'
import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

const reviewStore = useWorfklowReviewItems()
const { currentReviewItem: context } = storeToRefs(reviewStore)
</script>
